<template>
  <div :class="$style['pt-sub-title']">
      <div :class="$style['sub-title-content']">
          <div :class="$style['sub-title-text']">{{title}}
            <slot name="line"></slot>
          </div>
          <span v-if="showCollapse" :class="[isOpen ? 'el-icon-arrow-up' : 'el-icon-arrow-down',$style['collapse-btn']]" @click="toggle">
          </span>
          <slot v-else/>
      </div>
      <template v-if="showCollapse">
          <div ref="collapseBox" v-if="isOpen" :class="$style['sub-title-collapse']">
          <slot name="collapse-content"/>
        </div>
      </template>

      
      
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-sub-title'

export default {
  name: 'pt-sub-title',
  props: {
    title: {
      type: String,
      default: ''
    },
    showCollapse: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data(){
    return {
      isOpen:this.open
    }
  },
  watch:{
    open(val){
      this.isOpen = val
    }
  },
  methods:{
    toggle(){
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style module lang="less">
@import '~less/var.less';
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-sub-title{
    width: 100%;
    margin: 15px 0;
}
.sub-title-content{
    padding: 10px 20px;
    display:flex;
    justify-content:space-between;
    background-color: #F9F9F9;
    align-items: center;
    .collapse-btn{
      color: @mainColor;
      cursor: pointer;
    }
}
.sub-title-text{
    font-size: 16px;
}
</style>
